/*
 * A temporary account (Google sign-up not finalized: no birthday, no civility, generated nickname) stays on
 * /mon-profil, where the finalization form is shown, until the form is submitted: every other page comes back
 * here. The form opens again on each return (and on each click of the page, see pages/mon-profil.vue), so
 * that closing it never looks like a broken site.
 */

export default defineNuxtRouteMiddleware(async (to) => {
  // a temporary token with no session loaded yet (first page of a visit): checked with the API now, so that a
  // refused one (account deleted or finalized elsewhere, token expired) is dropped on any page, not only on
  // /mon-profil; until then it blocked Google One Tap for the 24 h of its cookie
  if (useTempJWTCookie().value && !useTempUser().value) {
    await useTempAuth().getTempSession({ force: true })
  }
  if (!useIsTempUser().value) return

  if (to.path !== '/mon-profil') {
    return navigateTo('/mon-profil')
  }

  // first load of the page: its onMounted opens the form once the modal container is mounted; opening it here,
  // during hydration, rendered it at the bottom of the page behind a grey overlay
  if (!import.meta.client || useNuxtApp().isHydrating) return

  const { updateProfileModal } = await import('~/modals/updateProfile')
  if (!updateProfileModal.options.modelValue) updateProfileModal.open()
})
